const homepage = {
  path: 'homepage',
  component: resolve => require(['../../../../components/pages/register/homepage'], resolve)
}

export default homepage



// WEBPACK FOOTER //
// ./src/router/pages/register/homepage/index.js